import createPage from "@src/components/page"
import React from "react"
import * as styles from "./pagePublish.module.scss"

import { callYou, useEnteringTrail } from "@src/components/page/lib"
import { animated } from "@react-spring/web"
import bgImg from "@images/2022/p10/38-100.jpg"
import penImg from "@images/2022/p10/39.png"
import paperImg from "@images/2022/p10/40.png"
import starImg from "@images/2022/p10/41.png"
import faceImg from "@images/2022/p10/42.png"

const parseData = ({
  attributes: {
    "articles-count": articles,
    "shows-count": shows,
    "talks-count": talks,
  },
  "favorite-topic": topic,
}) => ({
  articles,
  shows,
  talks,
  topic,
})

const PagePublish = createPage(
  ({ data, offset }) => {
    const { articles, shows, talks, topic } = parseData(data)
    const anime1Styles = useEnteringTrail(4, offset)
    const anime2Styles = useEnteringTrail(1, offset, { step: 0.2, type: "mt" })
    const anime3Styles = useEnteringTrail(1, offset, { step: 0.4, type: "mb" })
    const anime4Styles = useEnteringTrail(1, offset, { step: 1 })
    return (
      <>
        <animated.div style={anime2Styles[0]}>
          {(articles > 0 || shows > 0) && (
            <p>
              2022年 {callYou(data)}一共
              {articles > 0 && (
                <>
                  发布了
                  <br />
                  <b>{articles}</b>篇文章
                </>
              )}
              {shows > 0 && (
                <>
                  <br />
                  参与过
                  <b>{shows}</b>期电台和视频
                </>
              )}
            </p>
          )}
        </animated.div>
        <div className="iconsGroup">
          <div>
            <animated.img
              style={anime1Styles[0]}
              src={faceImg}
              className={styles.face}
              alt="icon"
            />
            <animated.img
              style={anime1Styles[1]}
              src={starImg}
              className={styles.star}
              alt="icon"
            />
            <animated.img
              style={anime1Styles[2]}
              src={paperImg}
              className={styles.paper}
              alt="icon"
            />
            <animated.img
              style={anime1Styles[3]}
              src={penImg}
              className={styles.pen}
              alt="icon"
            />
          </div>
        </div>
        <animated.div style={anime3Styles[0]}>
          {talks > 0 && (
            <>
              发布过<b>{talks}</b>个机组动态
              <br />
            </>
          )}

          {topic && (
            <>
              参与最多的机组话题是
              <br />
              <b>{topic.attributes.title}</b>
            </>
          )}
        </animated.div>

        <animated.div className="bottomText" style={anime4Styles[0]}>
          机核 2022 全年共产生 11517 篇投稿
          <br />及 230304 个机组动态
        </animated.div>
      </>
    )
  },
  {
    className: styles.page,
  }
)

export const pagePublishData = {
  key: "publish",
  bgImg,
  Page: PagePublish,
  shouldHide: (data) => {
    const { articles, shows, talks } = parseData(data)
    return articles === 0 && shows === 0 && talks === 0
  },
}

PagePublish.displayName = "PagePublish"
export default PagePublish
